import {IRouteProps} from "../../../../ts/manager/view/ViewInterface";
import StateViewController from "../../../vc/StateViewController";
import React, {useState} from "react";
import BasicForm from "../../../component/form/BasicForm";
import ApiResponseVO from "../../../../ts/manager/api/ApiResonseVO";
import {getManager} from "../../../../ts/manager/Manager";
import AppButton from "../../../element/button/AppButton";
import {AlertOptions} from "@ionic/react";
import {getModelFactory} from "../../../../ts/model-factory/ModelFactory";
import UserProfile from "../../../../ts/manager/user/UserProfile";
import {IFormProps} from "../../../component/form/model/FormModel";
import ApiError from "../../../../ts/manager/api/ApiError";
import {OrganisationUserDataModel, OrganisationUserType} from "../../../../ts/data/subject/OrganisationUserDataFactory";

interface IProps extends IFormProps
{
    userID: number;
    organisationID: number;
}

class AccountCloseForm extends BasicForm
{
    props: IProps;

    userID: number = 0;
    organisationID: number = 0;

    model: OrganisationUserDataModel|null = null;

    showCloseAccount = false;
    showRemoveOrganisation = false;
    showCloseAccountAndRemoveOrganisation = false;
    wouldTransferTo:UserProfile|null = null;

    constructor(props: IProps)
    {
        super(props);

        this.props = props;
    }


    initVariables()
    {
        super.initVariables();

        this.userID = this.props.userID;
        this.organisationID = this.props.organisationID;

        this.model = this.organisationID ? getModelFactory().organisationUserData.organisationUserDataModel(this.organisationID) : null;
    }

    async initModels(): Promise<void>
    {
        return this.requireModelPopulated().then((apiError) => {
            if(apiError){
                this.isInitializeInvalid = true;
            }
        });
    }

    applyCurrentState()
    {
        this.showCloseAccount = false;
        this.showRemoveOrganisation = false;
        this.showCloseAccountAndRemoveOrganisation = false;
        this.wouldTransferTo = null;

        const choiceList = (this.model?.choiceList() ?? []);
        let thisUserType:OrganisationUserType|null = null;
        for(let choice of choiceList){
            if(choice.profile.userID === this.userID){
                thisUserType = choiceList.length > 1 ? choice.userType : "author";
                break;
            }
        }
        if(thisUserType === "author"){

            choiceList.reverse();
            for(let choice of choiceList){
                if(choice.profile.userID !== this.userID){
                    this.wouldTransferTo = choice.profile;
                    break;
                }
            }
        }

        if(!thisUserType){
            this.showCloseAccount = true;
        } else {
            this.showCloseAccountAndRemoveOrganisation = true;
            this.showRemoveOrganisation = true;
            if(choiceList.length > 1){
                this.showCloseAccount = true;
            }
        }
    }

    async requireModelPopulated(): Promise<ApiError|null>
    {
        if(!this.model){
            this.applyCurrentState();
            return null;
        }
        return this.model.requirePopulated().then((apiError) => {
            if (apiError)
            {
                return apiError;
            } else {
                this.applyCurrentState();
                return null;
            }
        })
    }

    async handleSubmitItems(_: string[]|null, submitType: string): Promise<ApiResponseVO>
    {
        let responseVO:ApiResponseVO|null = null;
        if(["remove_organisation", "close_account_remove_organisation"].includes(submitType)){
            responseVO = await getManager().api.fetchData("/post/organisation/"+ this.organisationID +"/delete", "DELETE", null, true);
            if(responseVO.apiError){
                return responseVO;
            }
            this.organisationID = 0;
        } else if(submitType === "close_account"){
            if(this.wouldTransferTo){
                responseVO = await getManager().api.fetchData("/post/organisation/"+ this.organisationID +"/reassign_author/"+this.wouldTransferTo.userID, "POST", null, true);
                if(responseVO.apiError){
                    return responseVO;
                }
                this.organisationID = 0;
            }
        }
        if(["close_account", "close_account_remove_organisation"].includes(submitType)){
            responseVO = await getManager().api.fetchData("/account/close", "DELETE", null, true);
            if(responseVO.apiError){
                return responseVO;
            }
            this.userID = 0;
            this.organisationID = 0;
        }
        if(!this.userID || !this.organisationID){
            if(this.model){
                this.model.resetPopulated();
                this.model = null;
            }
            getModelFactory().resetFactories();
        }
        if(!this.organisationID){
            getManager().user.organisationID = 0;
        }
        this.applyCurrentState();
        return responseVO ?? new ApiResponseVO();
    }

    confirmationOptions(resolve: ((value: (boolean | PromiseLike<boolean>)) => void), submitType: string): AlertOptions | null
    {
        let header:string = "";
        let message:string = "Do you want to continue?";
        let confirmText = "Close Account";
        if(submitType === "close_account"){
            header = "You are about to permanently close your account.";
            if(this.wouldTransferTo){
                message = "Ownership of your organisation would transfer to " + this.wouldTransferTo.getName() + ". Do you want to continue?";
            }
        } else if(submitType === "remove_organisation"){
            header = "You are about to permanently remove your organisation.";
            confirmText = "Remove Organisation"
        } else if(submitType === "close_account_remove_organisation"){
            header = "You are about to permanently close your account and remove your organisation.";
        }
        return {
            header: header,
            message: message,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () =>
                    {
                        resolve(false);
                    },
                },
                {
                    text: confirmText,
                    role: 'confirm',
                    handler: () =>
                    {
                        resolve(true);
                    },
                }
            ]
        };
    }

    renderComponent()
    {

        return <>

            <form
                onSubmit={this.handleFormSubmit}
                className={"custom-form "+(this.isDisabled() ? "content-disabled" : "")}
            >
                {this.startFormAlerts()}
                {this.requiredFieldsMessage()}


                {this.endFormAlerts()}

                <div className="row">
                    <div className="col-12">
                        <p>Close your account?</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">

                        {this.showCloseAccount && <>
                            <div className="mt-4">
                                <AppButton
                                    type="submit"
                                    value="close_account"
                                    loading={this.loading}
                                    className="btn btn-block btn-primary"
                                    disabled={this.isSubmitDisabled()}
                                >
                                    Close Account
                                </AppButton>
                            </div>
                        </>}
                        {this.showRemoveOrganisation && <>
                            <div className="mt-4">
                                <AppButton
                                    type="submit"
                                    value="remove_organisation"
                                    loading={this.loading}
                                    className="btn btn-block btn-primary"
                                    disabled={this.isSubmitDisabled()}
                                >
                                    Remove Organisation
                                </AppButton>
                            </div>
                        </>}
                        {this.showCloseAccountAndRemoveOrganisation && <>
                            <div className="mt-4">
                                <AppButton
                                    type="submit"
                                    value="close_account_remove_organisation"
                                    loading={this.loading}
                                    className="btn btn-block btn-primary"
                                    disabled={this.isSubmitDisabled()}
                                >
                                    Close Account and Remove Organisation
                                </AppButton>
                            </div>
                        </>}
                    </div>
                </div>
            </form>

        </>;
    }
}

const AccountClosePage = (props:IRouteProps) =>
{
    const organisationID = getManager().user.organisationID;
    const userID = getManager().user.profile.userID;
    const [, setSimpleState] = useState<any[]>([]);

    const viewState = StateViewController({
        routeProps: props,
        redirectOnLogout: true
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    const onSubmit = (submitType?: string) => {

        if(submitType === "remove_organisation")
        {
            setSimpleState([]);
            return;
        }
        getManager().user.logOut();
    }

    return <>
        <section className="content-block">

            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <AccountCloseForm
                            routeProps={props}
                            userID={userID}
                            organisationID={organisationID}
                            onSubmit={onSubmit}
                        />
                    </div>
                </div>
            </div>
        </section>
    </>
}

export default AccountClosePage;